import React, { memo, useMemo } from "react"
import { useNavigation } from "../../hooks/useNavigation"

// export const withFooterCopyright = Component => ({ name = "FooterCopyright" }) => {
//   const copyright = null //"Site design by Friend of Mine"

//   Component.displayName = name
//   return <Component copyright={copyright} />
// }

export const withFooterCopyright = Component =>
  memo(({ name = "FooterCopyright" }: any) => {
    const { footer: items } = useNavigation()
    Component.displayName = name
    return useMemo(() => <Component items={items} />, [items])
  })
